"use strict";
/**
 * Defines how a round in a target structure should be populated with participants who travel across a link
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=interleave.js.map